import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"items":_vm.firms,"item-text":"display","item-value":_vm.itemValue,"hide-no-data":"","label":_vm.$t('labels.firm'),"required":"","error-messages":_vm.errors,"clearable":""},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }